import { Component, Vue } from 'vue-property-decorator';
import { Inject } from 'vue-di-container';
import WithRender from './PreApprovedTemplateInfo.html';
import PreApprovedTemplateService from './PreApprovedTemplateService';
import { PreApprovedTemplateModel } from './PreApprovedTemplateModel';
import { Toaster } from '../../Services/toast';
import { isolateTemplateVariablePlaceholders } from '../../shared/templateTextDirection';

@WithRender
@Component({
    diProvide: [PreApprovedTemplateService]
})
export default class PreApprovedTemplateInfo extends Vue {
    @Inject(PreApprovedTemplateService) public preApprovedTemplateService!: PreApprovedTemplateService;

    public model: PreApprovedTemplateModel = {
        id: '',
        templateCode: '',
        name: '',
        classification: 0,
        description: '',
        templateContent: '',
        isActive: false,
        createdDate: ''
    } as PreApprovedTemplateModel;

    public substitutedText: string = '';
    public baseTemplateContent: string = '';
    public templateTextDir: string = (typeof localStorage !== 'undefined' && localStorage.dir === 'rtl') ? 'rtl' : 'ltr';
    public id: string = '';
    public variablesMapping: Array<{ key: string, value: string }> = [];

    public setTemplateTextDir(dir: string): void {
        this.templateTextDir = dir === 'rtl' ? 'rtl' : 'ltr';
    }

    public get hasTemplateVariables(): boolean {
        return this.variablesMapping.length > 0;
    }

    public formatTemplateContentForDisplay(content: string): string {
        return isolateTemplateVariablePlaceholders(content || '');
    }

    public async mounted() {
        this.id = this.$route.params.id;
        await this.loadTemplateDetails();
    }

    public async loadTemplateDetails() {
        if (!this.id || this.id === 'undefined') {
            return;
        }

        const response = await this.preApprovedTemplateService.getById(this.id);

        if (response && response.isSuccess) {
            this.model = response.result || response.Result;
            this.buildTemplateContent();
        } else {
            Toaster.error(this.$t('shared.loadFailed').toString());
        }
    }

    private buildTemplateContent(): void {
        this.substitutedText = '';
        this.baseTemplateContent = '';
        this.variablesMapping = [];

        if (!this.model || !this.model.templateContent) {
            return;
        }

        try {
            const parsed = JSON.parse(this.model.templateContent);
            const text = parsed.text || '';
            const variables = parsed.variables || [];
            this.baseTemplateContent = text;

            if (Array.isArray(variables)) {
                for (let i = 0; i < variables.length; i++) {
                    this.variablesMapping.push({
                        key: '#Var' + (i + 1) + '#',
                        value: variables[i]
                    });
                }
            }

            const regex = /#Var(\d+)#/g;
            this.substitutedText = text.replace(regex, (match: string, num: string) => {
                const index = parseInt(num, 10) - 1;
                return (variables && variables[index]) ? variables[index] : match;
            });

        } catch (e) {
            this.baseTemplateContent = this.model.templateContent;
            this.substitutedText = this.model.templateContent;
            this.variablesMapping = [];

            const regex = /#Var(\d+)#/g;
            let match;
            while ((match = regex.exec(this.model.templateContent)) !== null) {
                const placeholder = match[0];
                let exists = false;

                for (let i = 0; i < this.variablesMapping.length; i++) {
                    if (this.variablesMapping[i].key === placeholder) {
                        exists = true;
                        break;
                    }
                }

                if (!exists) {
                    this.variablesMapping.push({
                        key: placeholder,
                        value: 'No Value'
                    });
                }
            }
        }
    }

    public classificationLabel(classification: number): string {
        const list = [
            { id: 1, name: this.$t('shared.Advertising').toString() },
            { id: 2, name: this.$t('shared.Service').toString() },
            { id: 3, name: this.$t('shared.Warning').toString() },
            { id: 5, name: this.$t('shared.Awareness').toString() },
        ];
        const item = list.find((c) => c.id === classification);
        return item ? item.name : String(classification);
    }

    public formatDate(dateValue: string): string {
        if (!dateValue) return '';
        const date = new Date(dateValue);
        return isNaN(date.getTime()) ? dateValue : date.toLocaleDateString('en-GB').replace(/\//g, '-');
    }
}